import { render, staticRenderFns } from "./VaimoCollectedProduct.vue?vue&type=template&id=3f4394ce&scoped=true&"
import script from "./VaimoCollectedProduct.vue?vue&type=script&lang=js&"
export * from "./VaimoCollectedProduct.vue?vue&type=script&lang=js&"
import style0 from "./VaimoCollectedProduct.vue?vue&type=style&index=0&id=3f4394ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4394ce",
  null
  
)

export default component.exports